import clsx from 'clsx';

type MetadataSectionCardProps = {
  title: string;
  icon?: React.ReactNode;
  description?: string;
  count?: number;
  countLabel?: string;
  accent?: boolean;
  children: React.ReactNode;
};

export const MetadataSectionCard: React.FC<MetadataSectionCardProps> = ({
  title,
  icon,
  description,
  count,
  countLabel,
  accent = false,
  children,
}) => {
  const showCount = typeof count === 'number';

  return (
    <div
      className={clsx(
        'flex flex-col w-full rounded-card border overflow-hidden',
        accent ? 'border-main bg-select shadow-sm' : 'border-border bg-gray-50'
      )}
    >
      <div
        className={clsx(
          'flex flex-col gap-y-1 px-5 py-4 border-b',
          accent ? 'border-main' : 'border-border'
        )}
      >
        <div className="flex items-center justify-between gap-x-3">
          <div className="flex items-center gap-x-3">
            {!!icon && (
              <span
                className={clsx(
                  'inline-flex items-center justify-center size-9 rounded-sm',
                  accent
                    ? 'bg-contrast text-main border border-main'
                    : 'bg-contrast text-secondary border border-border'
                )}
              >
                {icon}
              </span>
            )}
            <span className="text-mainText text-medium font-semibold">
              {title}
            </span>
          </div>
          {showCount && (
            <span
              className={clsx(
                'inline-flex items-center px-3 py-1 rounded-slug text-tiny font-semibold',
                accent
                  ? 'bg-contrast text-main border border-main'
                  : 'bg-contrast text-secondary border border-border'
              )}
            >
              {count} {countLabel ?? (count === 1 ? 'item' : 'items')}
            </span>
          )}
        </div>
        {!!description && (
          <span className="text-secondary text-small leading-snug">
            {description}
          </span>
        )}
      </div>

      <div className="px-4 py-4 bg-contrast">{children}</div>
    </div>
  );
};
